export default "__VITE_ASSET__CDLfkr$1__"